module.exports = __webpack_public_path__ + "static/img/service-h5-4.271150e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/service-h5-4.png
// module id = lA+J
// module chunks = 34